import en from "./en/lang.json";
import ru from "./ru/lang.json";
import uk from "./uk/lang.json";

export default
{
  en,
  ru,
  uk
}